'use strict';

import debounce from 'shared/js/util/debounce';
var states = require('storefront/util/states');
var endpoint = $('.suggestions-wrapper').data('url');
var endpointEinstein = $('.suggestions-einstein-wrapper').data('url');
var minChars = 3;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    // #CDIFF #DONE Custom version: return $(scope).parents('.header-site-search').find('.suggestions-wrapper');
    return $(scope).closest('.header-search-form').siblings('.suggestions-wrapper') || $(scope).siblings('.suggestions-wrapper');
}

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-einstein-wrapper element
 */
function getEinsteinSuggestionsWrapper(scope) {
    return $(scope).parents('.header-site-search').find('.suggestions-einstein-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    // SFRA version:
    // $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = '.search-mobile button.'; // #TODO FF #CDIFF FM, PF have ".search-mobile span."
    var iconSearch = 'fa-search';
    var iconSearchClose = 'fa-close';

    if (action === 'close') {
    // #TODO FF #CDIFF .attr('type', 'button');
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
    } else {
    // #TODO FF #CDIFF .attr('type', 'submit');
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();

    if (typeof (response) !== 'object') {
        $suggestionsWrapper.append(response).show();
        $(this).siblings('.reset-button').addClass('d-sm-block');
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon('close');
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
        $('.popular-search').removeClass('hide');
    }
}

/**
 * Process Ajax response for SearchServices-GetEinsteinSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processEinsteinResponse(response) {
    var $suggestionsEinsteinWrapper = getEinsteinSuggestionsWrapper('input.search-field').empty();

    if (!(typeof (response) === 'object')) {
        $suggestionsEinsteinWrapper.append(response).show();
    }
}

/**
 * Retrieve Einstein suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getEinsteinSuggestions() {
    $.ajax({
        url: endpointEinstein,
        method: 'GET',
        success: processEinsteinResponse,
    }).always(function () {
        $.spinner().stop();
    });
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse
        });
        $('.popular-search').addClass('hide');
        $('button.clear-search').removeClass('hide');
        $('body').addClass('overflow-hidden body-fixed');
    } else {
        toggleSuggestionsIcon('search');
        $(scope).siblings('.reset-button').removeClass('d-sm-block');
        clearModals();
        getSuggestionsWrapper(scope).empty();
        getEinsteinSuggestions();
        $('.popular-search').removeClass('hide');
        $('button.clear-search').removeClass('hide');
        $('body').addClass('overflow-hidden body-fixed');
    }
}

function closeSearchDropdown() {
    $('input.search-field').blur(); // stop focusing input after click on clear search
    $('.suggestions').hide();
    $('.header').removeClass('remove-link-events');
    $('body').removeClass('overflow-hidden body-fixed');
    $('.overlay-search').addClass('hide');
    $('.popular-search').addClass('hide');
    toggleSuggestionsIcon('search');
    $('button.clear-search').addClass('hide');
    tearDownSuggestions();

    var isMobileDevice = (
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(navigator.userAgent) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(navigator.userAgent)
    );

    if (isMobileDevice) {
        $('header + div a').trigger('focus');
    } else {
        $('.header-sticky-icons .header-user-icon .header-login-link').trigger('focus');
    }
}

function terminateSearchProcess(e) {
    e.preventDefault();
    $('.suggestions').hide();
    e.stopPropagation();
    tearDownSuggestions();
    closeSearchDropdown();
    $('.header-search-input').val('');
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $('.suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

module.exports = function () {
    $('form[name="simpleSearch"]').submit(function (e) {
        var suggestionsList = $('.suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $('input.search-field').each(function () {
    /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);

        $(this).on('keyup focus', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
            case DOWN_KEY:
                handleArrow(DIRECTION_DOWN);
                e.preventDefault(); // prevent moving the cursor
                break;
            case UP_KEY:
                handleArrow(DIRECTION_UP);
                e.preventDefault(); // prevent moving the cursor
                break;
            default:
                debounceSuggestions(this, e);
            }
            $('.overlay-search').removeClass('hide');
            $('.header').addClass('remove-link-events');
            $('.header-search-dropdown').addClass('opened');
        });
    });

    $('body').on('click', function (e) {
        if (!$('.suggestions').has(e.target).length && !$(e.target).hasClass('search-field') && $(e.target).hasClass('body.overflow-hidden.modal-open')) {
            $('.suggestions').hide();
        }
    });


    // #CDIFF #MONITOR SFRA6 has another logic for the next 2 functions
    $('body').on('click', 'button.clear-search', function (e) {
        terminateSearchProcess(e);
    });

    var lastKeyPressed = null;
    var shiftPressed = null;

    $('.header-site-search').on('keydown', function (e) {
        lastKeyPressed = e.code;
        shiftPressed = e.shiftKey;

        if (lastKeyPressed == 'Escape') {
            terminateSearchProcess(e);
        }
    });

    $('.header-site-search').on('blur', function () {
        if (lastKeyPressed == 'Tab' && shiftPressed) {
            $('input.search-field').blur(); // stop focusing input after click on clear search
            $('.suggestions').hide();
            $('.header').removeClass('remove-link-events');
            $('body').removeClass('overflow-hidden body-fixed');
            $('.overlay-search').addClass('hide');
            $('.popular-search').addClass('hide');
            toggleSuggestionsIcon('search');
            $('button.clear-search').addClass('hide');
            tearDownSuggestions();
            $('.header-logo-big a').trigger('focus');
        }
    });

    $('body').on('blur', '.popular-search .popular-search-dropdown-help-list-li:last-child a, .view-more-products .view-more-products-link', function () {
        if (lastKeyPressed == 'Tab' && !shiftPressed) {
            closeSearchDropdown();
        }
    });

    $('.header-site-search').on('keydown', function (e) {
        if (e.code == 'Escape') {
            e.preventDefault();
            $('.suggestions').hide();
            e.stopPropagation();
            tearDownSuggestions();
            closeSearchDropdown();
            $('.header-search-input').val('');
        }
    });

    $('body').on('click', '.overlay-search', function () {
        closeSearchDropdown();
    });

    states.add('search', $('.state-container--search'), $('.search-state-trigger'), {
        onActivate: function () {
            setTimeout(function () {
                $('.search-field').focus();
            }, 50);
        }
    });

    $('.site-search .reset-button').on('click', function () {
        $(this).removeClass('d-sm-block');
    });
};
